import { render, staticRenderFns } from "./styles.vue?vue&type=template&id=3481e385&"
var script = {}
import style0 from "./styles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../production/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports